import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import ar from "@/locales/ar.json";
import en from "@/locales/en.json";

const DICTS = { ar, en };
const DEFAULT_LOCALE = "ar";
const SUPPORTED = ["ar", "en"];

const I18nContext = createContext({
  locale: DEFAULT_LOCALE,
  t: (key) => key,
  dict: ar,
});

export const detectLocaleFromPath = (pathname) => {
  const seg = pathname.split("/").filter(Boolean)[0];
  if (SUPPORTED.includes(seg)) return seg;
  return DEFAULT_LOCALE;
};

const getByPath = (obj, path) => {
  if (!obj) return undefined;
  return path.split(".").reduce((acc, k) => {
    if (acc === undefined || acc === null) return undefined;
    return acc[k];
  }, obj);
};

export const I18nProvider = ({ children, forceLocale }) => {
  const location = useLocation();
  const locale = forceLocale || detectLocaleFromPath(location.pathname);
  const dict = DICTS[locale] || DICTS[DEFAULT_LOCALE];

  const value = useMemo(() => {
    const t = (key, fallback) => {
      const v = getByPath(dict, key);
      if (v === undefined || v === null) return fallback !== undefined ? fallback : key;
      return v;
    };
    return { locale, t, dict };
  }, [locale, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
export const SUPPORTED_LOCALES = SUPPORTED;
